// context/AuthContext.jsx
import { createContext, useContext, useState, useEffect } from "react";

const AuthContext = createContext();

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => {
    const token = localStorage.getItem("token");
    if (!token) return null;
    try {
      const payload = JSON.parse(atob(token.split(".")[1]));
      if (payload.exp * 1000 < Date.now()) {
        localStorage.removeItem("token");
        return null;
      }
      return { userId: payload.userId, email: payload.email };
    } catch {
      localStorage.removeItem("token");
      return null;
    }
  });

  // 새로고침 후 복원
  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) return;
    try {
      const payload = JSON.parse(atob(token.split(".")[1]));
      // 만료 체크
      if (payload.exp * 1000 < Date.now()) {
        localStorage.removeItem("token");
        return;
      }
      setUser({ userId: payload.userId, email: payload.email });
    } catch {
      localStorage.removeItem("token");
    }
  }, []);

  function login(token) {
    localStorage.setItem("token", token);
    const payload = JSON.parse(atob(token.split(".")[1]));
    setUser({ userId: payload.userId, email: payload.email });
  }

  function logout() {
    localStorage.removeItem("token");
    setUser(null);
  }

  // API 호출 시 헤더에 토큰 붙이는 헬퍼
  function authHeader() {
    const token = localStorage.getItem("token");
    return token ? { Authorization: `Bearer ${token}` } : {};
  }

  return (
    <AuthContext.Provider value={{ user, login, logout, authHeader }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);